import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import moment from 'moment';
import fieldsChoose from './fieldsChoose.vue';
import LabelChoose from './labelChoose.vue';
import { LANGUAGE_RESOURCE } from '@/utils/public';
import { policyStateData,
// examineStateData,
orderStateData, orderTypeData, getExportParams, filterGetLabel } from './utils';
import { searchParams, fieldList, reportExport, customerResource } from './request';
export default {
  components: {
    fieldsChoose,
    LabelChoose
  },
  data() {
    return {
      policyStateData,
      // examineStateData,
      orderStateData,
      orderTypeData,
      policyAscriptionData: [],
      // 保单归属下拉
      exportType: undefined,
      // 列表类型
      rule: {},
      form: {
        time: [],
        insuranceId: undefined,
        customerId: undefined,
        // 保单归属
        recordMethod: undefined,
        // 录单方式
        orderType: undefined,
        // 订单类型
        policyState: undefined,
        orderState: undefined,
        claimState: undefined
      },
      productList: [],
      templateParam: [],
      // 保单动态模版字段key[]
      fixedFieldList: [],
      checkedFixedFieldList: [],
      isCustomer: this.$store.state.user.accountInfo.tag,
      tags: [],
      // tags参数
      tagsData: [],
      isLoading: false,
      disable: false,
      tagsParam: {} // params参数
    };
  },
  mounted() {
    if (this.isCustomer === 0) {
      this.rule = {
        time: this.exportRules.time
      };
    } else {
      this.rule = {
        time: this.exportRules.time,
        customerId: this.exportRules.customerId
      };
    }
  },
  computed: {
    ifShow() {
      switch (this.exportType) {
        case 1:
          return this.form.time.length || this.form.insuranceId;
        case 2:
          return this.form.time.length;
        case 3:
          return this.form.insuranceId;
      }
      return undefined;
    },
    defaultValue() {
      // if (this.form.time[0] && this.form.time[1]) {
      //   let startIsToday = moment(this.form.time[0]).isSame(moment(), 'days');
      //   let endIsToday = moment(this.form.time[1]).isSame(moment(), 'days');
      //   let a = moment().format('HH:mm:ss');
      //   if (startIsToday && endIsToday) {
      //     return [moment(a, 'HH:mm:ss'), moment(a, 'HH:mm:ss')];
      //   } else if (endIsToday) {
      //     return [moment('00:00:00', 'HH:mm:ss'), moment(a, 'HH:mm:ss')];
      //   }
      // }
      return [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')];
    },
    exportRules() {
      return {
        time: [{
          required: true,
          message: this.$t('请选择') + this.$t('导出时间'),
          trigger: 'change'
        }],
        customerId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保单归属'),
          trigger: 'change'
        }],
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('导出产品'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    openChangeDate(status) {
      if (status) {
        this.form.time = [];
        this.fixedFieldList = [];
        this.checkedFixedFieldList = [];
        this.templateParam = [];
      }
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledRangeTime(dates, type) {
      let hours = moment().hours(); //0~23
      let minutes = moment().minutes(); //0~59
      let seconds = moment().seconds(); //0~59
      //当日只能选择当前时间之后的时间点
      if (this.form.time[1] && moment(this.form.time[1]).date() === moment().date() && type === 'end' || this.form.time[0] && moment(this.form.time[0]).date() === moment().date() && type === 'start') {
        console.log(this.range(0, hours), this.range(0, minutes));
        return {
          disabledHours: () => this.range(hours + 1, 24),
          disabledMinutes: () => this.range(minutes + 1, 60),
          disabledSeconds: () => this.range(seconds + 1, 60)
        };
      }
      return {
        disabledHours: () => this.range(23, 23),
        disabledMinutes: () => this.range(59, 59),
        disabledSeconds: () => this.range(59, 59)
      };
    },
    disabledDate(current) {
      return current && moment().endOf('day') < current;
    },
    disabledThreeMonth(date) {
      if (date.length) {
        if (date[0] < moment(date[1]).subtract(3, 'months').startOf('days')) {
          return true;
        }
        return false;
      }
    },
    async onChangeExportList(e) {
      var _this$$refs$exportFor;
      this.isLoading = false;
      (_this$$refs$exportFor = this.$refs.exportForm) === null || _this$$refs$exportFor === void 0 || _this$$refs$exportFor.resetFields();
      this.clearForm();
      let type = getExportParams(e.target.value);
      if (e.target.value === 3) {
        this.exportRules.customerId[0].message = this.$t('请选择') + this.$t('保单归属');
        this.rule = this.exportRules;
      } else {
        if (e.target.value === 2) {
          this.exportRules.customerId[0].message = this.$t('请选择') + this.$t('订单归属');
        } else {
          this.exportRules.customerId[0].message = this.$t('请选择') + this.$t('保单归属');
        }
        if (this.isCustomer === 0) {
          this.rule = {
            time: this.exportRules.time
          };
        } else {
          this.rule = {
            time: this.exportRules.time,
            customerId: this.exportRules.customerId
          };
        }
      }
      if (this.isCustomer === 0) {
        this.policyAscriptionData = [];
        const {
          customerInsuranceData
        } = await searchParams({
          type,
          customerId: this.$store.state.user.accountInfo.customerId
        });
        this.productList = customerInsuranceData;
      } else {
        this.productList = [];
        const {
          policyAscriptionData = []
        } = await customerResource({
          type,
          customerId: this.$store.state.user.accountInfo.customerId
        });
        this.policyAscriptionData = policyAscriptionData;
      }
    },
    // 导出时间change
    onChangeExportTime(date) {
      if (this.isLoading || this.form.time.length === 0) {
        if (this.form.time.length === 0) {
          this.fixedFieldList = [];
          this.checkedFixedFieldList = [];
          this.templateParam = [];
        }
        return;
      }
      if (moment(this.form.time[0]).isSame(moment(this.form.time[1]))) {
        return this.$message.warn(this.$t('导出时间不能相同'));
      }
      if (date.length) {
        let startIsToday = moment(this.form.time[0]).isSame(moment(), 'days') && moment(this.form.time[0]).isAfter(moment());
        let endIsToday = moment(this.form.time[1]).isSame(moment(), 'days') && moment(this.form.time[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.form.time[0] = moment();
            this.form.time[1] = moment();
          } else if (endIsToday) {
            this.form.time[1] = moment();
          }
        }
      }
    },
    async okTime() {
      if (this.isLoading || this.form.time.length === 0) {
        return;
      }
      if (moment(this.form.time[0]).isSame(moment(this.form.time[1]))) {
        return this.$message.warn(this.$t('导出时间不能相同'));
      }
      this.fixedFieldList = [];
      this.checkedFixedFieldList = [];
      this.templateParam = [];
      this.isLoading = true;
      if (this.disabledThreeMonth(this.form.time)) {
        this.form.time = [];
        this.$message.warn(this.$t('最多可选择3个月'));
        this.isLoading = false;
      } else {
        if (this.isCustomer === 0 || this.form.customerId) {
          await this.getField();
        } else {
          this.isLoading = false;
        }
      }
    },
    // 保单归属change
    async onCustomerIdChange() {
      this.productList = [];
      this.form.insuranceId = undefined;
      this.isLoading = true;
      if (this.form.customerId) {
        let type = getExportParams(this.exportType);
        const {
          customerInsuranceData
        } = await searchParams({
          type,
          customerId: this.isCustomer === 0 ? this.$store.state.user.accountInfo.customerId : this.form.customerId
        });
        this.productList = customerInsuranceData;
        this.fixedFieldList = [];
        this.checkedFixedFieldList = [];
        this.templateParam = [];
        if (this.isCustomer !== 0) {
          await this.getField();
        } else {
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
      }
    },
    // 产品change
    async onProductChange() {
      if (this.isLoading || this.form.time.length === 0) {
        return;
      }
      if (this.exportType !== 2) {
        this.isLoading = true;
        this.fixedFieldList = [];
        this.checkedFixedFieldList = [];
        this.templateParam = [];
        await this.getField();
      } else {
        this.isLoading = false;
      }
    },
    // 获取导出字段
    async getField() {
      let type = getExportParams(this.exportType);
      let params;
      if (this.isCustomer === 0) {
        params = {
          type,
          insuranceId: this.form.insuranceId,
          startTime: moment(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss')
        };
      } else {
        params = {
          type,
          insuranceId: this.form.insuranceId,
          customerId: this.form.customerId,
          startTime: moment(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss')
        };
      }
      try {
        const {
          fixedParam = {},
          templateParam = {},
          tagsParam = []
        } = await fieldList(params);
        this.tagsData = tagsParam.map(item => {
          if (item.children) {
            item.checkAll = false;
            item.indeterminate = false;
            item.children.map(i => {
              i.checked = false;
            });
            return item;
          }
        });
        // debugger
        for (const key in fixedParam) {
          if (Object.hasOwnProperty.call(fixedParam, key)) {
            // 0为普通客户，1为保司，2为中介
            if (this.isCustomer === 0) {
              if (this.exportType === 1 && key === 'customerName') {
                continue;
              } else if (this.exportType === 2 && key === 'customerName') {
                continue;
              } else if (this.exportType === 3 && key === 'customerName') {
                continue;
              }
            } else if (this.isCustomer === 1) {
              if ((this.exportType === 1 || this.exportType === 2) && key === 'agencyName') {
                continue;
              }
            }
            this.fixedFieldList.push({
              label: fixedParam[key],
              value: key
            });
            this.checkedFixedFieldList.push(key);
          }
        }
        // 保单动态字段
        if (this.form.insuranceId && this.exportType !== 2) {
          for (const key in templateParam) {
            if (Object.hasOwnProperty.call(templateParam, key)) {
              this.fixedFieldList.push({
                label: templateParam[key],
                value: key
              });
              this.templateParam.push({
                label: templateParam[key],
                value: key
              });
            }
          }
        }
      } catch (error) {
        return;
      }
      this.isLoading = false;
    },
    getCheckedList(data) {
      this.checkedFixedFieldList = data;
      console.log(data, this.checkedFixedFieldList, 'info');
    },
    getLabelList() {
      this.tags = [];
      this.tagsParam = {};
      this.tagsData.map(item => {
        if (item.children && item.children.length) {
          // debugger;
          if (item.children.some(i => i.checked)) {
            Object.assign(this.tagsParam, {
              [item.children[0].fieldName]: item.fieldKey
            });
          }
          item.children.map(i => {
            if (i.checked) {
              this.tags.push({
                fieldName: i.fieldName,
                fieldValue: i.fieldValue
              });
            }
          });
        }
      });
      // console.log(this.tags, 'label');
    },
    onExport() {
      const h = this.$createElement;
      this.$refs.exportForm.validate(async valid => {
        if (valid) {
          let that = this;
          this.disable = true;
          const languageCode = sessionStorage.getItem('locale') || 'zh_CN';
          let obj = {
            userId: this.$store.state.user.accountInfo.id,
            customerId: this.isCustomer !== 0 ? this.form.customerId : this.$store.state.user.accountInfo.customerId,
            exportType: getExportParams(this.exportType),
            insuranceId: this.form.insuranceId,
            startTime: moment(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss'),
            language: LANGUAGE_RESOURCE[languageCode]
          };
          await reportExport(Object.assign(this.exportParams(), obj));
          // console.log(that.$confirm);
          that.$confirm({
            title: that.$t('任务已开始执行'),
            content: h => h("div", [that.$t('如需了解执行进度请点击右上角进入“任务中心”查看')]),
            icon: h => h("a-icon", {
              "attrs": {
                "type": "check-circle",
                "theme": "twoTone"
              }
            }),
            okText: that.$t('查看'),
            onOk() {
              that.$router.push('/task');
            },
            onCancel() {},
            class: 'test'
          });
          this.disable = false;
        }
      });
    },
    exportParams() {
      const templateParam = [];
      this.templateParam.filter(item => {
        if (this.checkedFixedFieldList.includes(item.value)) {
          templateParam.push(item.value);
        }
      });
      const fixedParam = this.checkedFixedFieldList.filter(item => {
        if (!templateParam.includes(item)) {
          return item;
        }
        // return this.checkedFixedFieldList.includes(item);
      });
      switch (this.exportType) {
        case 1:
          return {
            status: this.form.policyState,
            recordMethod: this.form.recordMethod,
            tags: JSON.stringify([this.tags]),
            params: {
              fixedParam: filterGetLabel(this.fixedFieldList, fixedParam),
              templateParam: filterGetLabel(this.fixedFieldList, templateParam),
              tagsParam: this.tagsParam
            }
          };
        case 2:
          return {
            status: this.form.orderState,
            orderType: this.form.orderType,
            tags: JSON.stringify([this.tags]),
            // 订单列表没有标签字段
            params: {
              fixedParam: filterGetLabel(this.fixedFieldList, fixedParam)
              // tagsParam: this.tagsParam
            }
          };
        case 3:
          return {
            status: this.form.claimState,
            tags: JSON.stringify([this.tags]),
            params: {
              fixedParam: filterGetLabel(this.fixedFieldList, fixedParam),
              templateParam: filterGetLabel(this.fixedFieldList, templateParam),
              tagsParam: this.tagsParam
            }
          };
        default:
          break;
      }
    },
    clearForm() {
      this.form.policyState = undefined;
      this.form.orderState = undefined;
      this.form.claimState = undefined;
      this.form.orderType = undefined;
      this.form.recordMethod = undefined;
      this.form.customerId = undefined;
      this.fixedFieldList = [];
      this.checkedFixedFieldList = [];
      this.templateParam = [];
    }
  }
};